<div class="flex flex-col justify-center items-center w-full  transition-all duration-300 ">
    <div class="flex justify-between items-center w-full">


        <div tabindex="0" (keydown)="keyDwn($event,data!.route)"
            class="flex nested-elem  {{expanded && !mobile ? ' border-primary-50/50 rounded-none bg-none nested-elem-nobg' : 'mr-2  rounded-xl'}}  nested-elem-focus  grow  text-sm cursor-pointer {{data!.cssClass}}" >
            <div class="flex gap-2 items-center  {{expanded && !mobile ? 'icon-text-collapse' : 'icon-text-expand'}}" (click)="onNodeSelect(data!.route)">
    
                <div @onOff class="flex items-center justify-center {{expanded && !mobile ? 'icon-collapse text-colored' : 'icon-expand'}}">
                    <div *ngIf="data?.icon != undefined" class="w-full {{data?.icon}}"></div>
                    <div *ngIf="data?.icon == undefined && parentIcon != undefined" class="w-full {{parentIcon}} "></div>
                    <div *ngIf="data?.icon == undefined && parentIcon == undefined" class="w-full icon-placeholder "></div>
                </div>
    
                <div class="text-left select-none {{expanded && !mobile ? 'text-collapse' : 'text-expand'}}">
                    <p [title]="data?.name" class="select-none"> {{ data!.name.length > 18 ? (data!.name.slice(0, 18) + '...') : data!.name }}</p>
                </div>
            </div>
    
    
            <!--     <div class="text-left cursor-pointer select-none pl-2 {{expanded ? 'icon-collapse' : 'icon-expand'}}" (click)="onNodeSelect(data!.route)"
                *ngIf="data!.children.length ==0">
                <p class="select-none break-before-all">{{data!.name}}</p>
            </div> -->
    
    
            <div tabindex="0" (keydown)="expandOnFocus($event,data!.name)" (click)="expandNode(data!.name)"
                *ngIf="data!.children.length >0 && !expanded" style="width: 5%;"
                class="w-3/12 flex items-center justify-end cursor-pointer chevron-focus">
                <div class="w-5 h-5 circular-focus">
    
    
                    <div class="w-5 h-5 {{data?.iconClass}} ">
                        
                    </div>
    
                </div>
            </div>
    
    
        </div>
    
        <ejs-tooltip target="#openNew" content="Apri in una nuova scheda" class="{{expanded && !mobile ? 'button-collapse' : 'button-expand'}}">
    
            <button nodisable="true" tabindex="-1" id="openNew" class="new-button rounded-lg p-2 "
                (click)="newWindow(data!.route)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-4 h-4">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                </svg>
            </button>
    
        </ejs-tooltip>
    </div>
    
    
    <div class="w-full h-full relative rounded-lg {{data!.expand && data!.children.length > 0 && !expanded ? 'showChildren' : 'hideChildren'}}" >

        <div *ngFor="let children of data!.children" class="pl-4 mt-2">
            <app-node [data]="children" [expand]="data!.expand" [parentIcon]="data?.icon || parentIcon" [mobile]="mobile"
                (onNodeClick)="onNodeSelect($event)"></app-node>

        </div>
    </div>
</div>